module.exports = __webpack_public_path__ + "static/media/Logos for Property Page.c69a6a0b.png";